import Vue          from 'vue';
import store        from './store';
import domready     from 'domready';
import EventManager from 'dd-event-manager';



const rootSettings = {
  store,



  data() {
    return {
      state: 'pending',
      expelFixedItems: [],
      hasExpelFixed: false,
    }
  },



  computed: {
    isInitialized() { return this.state === 'initialized' },
    year() { return this.$store.getters['banner/config/year'] },
    breakPoint() { return this.$store.getters['banner/config/breakPoint'] },
  },



  async created() {
    new EventManager(this);

    this.segments = new BcSegments();
    this.$store.dispatch('banner/config/load');
    this.$store.dispatch('banner/data/load');
    this.apply(document.documentElement, {autoload: true});

    this.$on('expelFixedItemVisibledChange', child => {
      this.onExpelFixedItemVisibledChange(child);
    });
  },



  watch: {
    year() {
      if (this.year) {
        this.init();
      }
    },
    hasExpelFixed() {
      this.$emit('hasExpelFixedChange', this.hasExpelFixed);
    },
  },



  methods: {
    onExpelFixedItemVisibledChange(child) {
      if (child.visible) {
        this.expelFixedItems.push(child._uid);
      } else {
        const targetIndex = this.expelFixedItems.indexOf(child._uid);
        if (targetIndex !== -1) this.expelFixedItems.splice(targetIndex, 1);
      }
      this.hasExpelFixed = this.expelFixedItems.length > 0;
    },

    ready() {
      if (this.isInitialized) return Promise.resolve();
      return new Promise(resolve => {
        this.hasAndOn('init.ready', () => {
          this.off('.ready');
          resolve();
        });
      });
    },

    async init() {
      await Promise.all([
        this.domready(),
        this.segments.ready(),
        this.$store.dispatch('banner/data/ready'),
        this.$store.dispatch('banner/mq/ready'),
      ]);

      this.$store.dispatch('banner/segments/init', this.segments);

      this.state = 'initialized';
      this.emit('init');
    },

    setYear(year) {
      this.segments.setYear(year);
      this.$store.commit('banner/config/setYear', year);
    },

    domready() {
      return new Promise(resolve => {
        domready(resolve);
      });
    },

    async apply(context = document.documentElement, opt = {}) {
      await this.ready();

      const $items = context.getAttribute('data-is') === 'bc-banner' ? [context] : Array.prototype.slice.call(
        document.querySelectorAll(
          '[data-is="bc-banner"]:not([data-mounted="true"])' + (opt.autoload ? ':not([data-autoload="false"])' : '')
        )
      );

      // 先に「data-fixed」がついてないものをすべて初期化する
      // おっかけバナーの表示判定のため
      const $fixedItem   = $items.find($item => $item.dataset.fixed !== 'false' && $item.dataset.fixed !== undefined);
      const $normalItems = $items.filter( $item => $item.dataset.fixed === undefined || $item.dataset.fixed === 'false');

      if ($normalItems.length) {
        const normalPromiseList = $normalItems.map($item => {
          return this.applyElement($item, opt);
        });

        const contexts = await Promise.all(normalPromiseList);
        const allCreatedPromiseList = contexts.map(context => {
          return new Promise((resolve, reject) => {
            context.$banner.hasAndOn('created', resolve);
          });
        });

        await Promise.all(allCreatedPromiseList);
        await this.$nextTickPromise();
      }

      if ($fixedItem) await this.applyElement($fixedItem, opt);
    },

    async applyElement(el, opt = {}) {
      await this.ready();

      const parent          = opt.parent   || this;
      const data            = el.dataset   || {};
      const ui              = data.ui      || 'rotate';
      const screen          = data.screen  || null;
      const type            = data.type    || null;
      const forceMq         = data.forceMq || null;
      const backgroundColor = data.backgroundColor || null;
      const size            = {};
      const fixed           = data.fixed      === 'false' ? false : data.fixed      !== undefined;
      const expelFixed      = data.expelFixed === 'false' ? false : data.expelFixed !== undefined;

      const zIndex = data.zIndex;
      const tag    = `bc-banner-${ui}`;
      ['pc', 'sp'].forEach(key => {
        size[key] = {
          width : parseInt(data[`${key}Width` ] , 10) || null,
          height: parseInt(data[`${key}Height`] , 10) || null,
        };
      });

      let context = {
        el: el,
        _el: document.createElement('div'),
        onMq: mq => {
          el.setAttribute('data-mq', mq);
        },
        onExist: exist => {
          el.setAttribute('data-exist', exist);
          opt.onExist && opt.onExist(exist);
        },
        destroy: () => {
          if (context.$vm._isDestroyed) return;
          context.$vm.$destroy();
        },
        onBeforeDestroy: () => {
        },
        onDestroyed: () => {
          el.removeAttribute('data-mq');
          el.removeAttribute('data-exist');
          el.removeAttribute('data-mounted');
          context.el = null;
          context._el = null;
          context.$vm = null;
          delete context.el;
          delete context._el;
          delete context.$vm;
          if (el.firstChild) el.removeChild(el.firstChild);
          context = null;
        },
      };
      el.appendChild(context._el);
      context.$vm = new Vue({
        store,
        el    : context._el,
        parent: parent,

        render(h) {
          return h(tag, {
            props: {
              screen         : screen,
              type           : type,
              size           : size,
              forceMq        : forceMq,
              fixed          : fixed,
              expelFixed     : expelFixed,
              zIndex         : zIndex,
              backgroundColor: backgroundColor,

              onMq           : context.onMq,
              onExist        : context.onExist,
              onBeforeDestroy: context.onBeforeDestroy,
              onDestroyed    : context.onDestroyed,
            },
          });
        },
      });
      context.$banner = context.$vm.$children[0];

      el.setAttribute('data-mounted', true);

      return context;
    },
  },
};




export default rootSettings;



// WEBPACK FOOTER //
// ./src/shared/bc-banner/root.js